export let ManifestDefinitions = /*#__PURE__*/function (ManifestDefinitions) {
  ManifestDefinitions["behaviors"] = "editingBehaviors";
  ManifestDefinitions["style"] = "style";
  ManifestDefinitions["rootManifestData"] = "rootManifestData";
  ManifestDefinitions["compType"] = "compType";
  return ManifestDefinitions;
}({});

// TODO: remove overflowOption and ExtraEditingBehaviors after original EditingBehaviors will be updated
//# sourceMappingURL=types.js.map